import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { ChromePicker } from "react-color";

import { Field, Control, Label, Button, Icon } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "./ColorPicker.scss";

const ColorPicker = ({
  name = "Color",
  value: initialValue = "#000",
  onChange = console.log
}) => {
  const [value, setValue] = useState("");
  const [showColorPicker, setShowColorPicker] = useState(false);

  useEffect(() => {
    if (initialValue) {
      setValue(initialValue);
    }
  }, [initialValue]);

  const handleChange = ({ hex }) => {
    setValue(hex);
  };
  const handleOpenPicker = () => {
    setShowColorPicker(true);
  };
  const handleClosePicker = () => {
    setShowColorPicker(false);
    onChange({ target: { name, value } });
  };
  const handleClearClick = () => {
    setValue("");
    onChange({
      target: {
        name,
        value: ""
      }
    });
  };
  return (
    <Field>
      <Label>{name}</Label>

      <Field kind="addons" onBlur={onChange}>
        <Control>
          <Button
            className="clear-button"
            role="button"
            type="button"
            onClick={handleClearClick}
          >
            <Icon>
              <FontAwesomeIcon icon="times" />
            </Icon>
          </Button>
        </Control>
        <Control>
          <div className="color-picker-container">
            <div
              className="swatch"
              role="button"
              tabIndex="0"
              onClick={handleOpenPicker}
              onKeyDown={handleOpenPicker}
            >
              <div className="color" style={{ backgroundColor: value }} />
            </div>
            {showColorPicker && (
              <div className="popover">
                <div
                  role="button"
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0
                  }}
                  tabIndex="-1"
                  onClick={handleClosePicker}
                  onKeyDown={handleClosePicker}
                />
                <ChromePicker
                  disableAlpha
                  color={value}
                  onChange={handleChange}
                />
              </div>
            )}
          </div>
        </Control>
      </Field>
    </Field>
  );
};

ColorPicker.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func
};
export default ColorPicker;
